import { type ListingMapFeature } from '@/features/listing/types/listing-types';
import { type ListingsMapSearchResponse } from '@/features/listing/types/listings-search-response-types';

export default function listingMapAdapter(listingMap: ListingsMapSearchResponse): ListingMapFeature {
  const {
    lat,
    listing_id,
    lng,
  } = listingMap;

  return {
    geometry: {
      coordinates: [lng, lat],
      type: 'Point',
    },
    properties: { listingId: listing_id },
    type: 'Feature',
  };
}
